import { z } from 'zod';

export const ADDRESS_ROLE_MAP = {
  BILLING: 'Billing',
  SHIPPING: 'Shipping',
  WAREHOUSE: 'Warehouse',
  PRIMARY_BUSINESS: 'Primary Business',
  SUBSIDIARY: 'Subsidiary',
  OTHER: 'Other',
};

export const editBusinessEntityZod = z.object({
  name: z.string().optional().nullable(),
  bluebookId: z.string().optional().nullable(),
  roles: z.array(z.string()).optional().nullable(),
  disabled: z.boolean().optional(),
  customFields: z.any().optional().nullable(),
  receivablesAccount: z
    .object({
      id: z.number().optional().nullable(),
      accountName: z.string().optional().nullable(),
      accountNumber: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
  payablesAccount: z
    .object({
      id: z.number().optional().nullable(),
      accountName: z.string().optional().nullable(),
      accountNumber: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
  incomeAccount: z
    .object({
      id: z.number().optional().nullable(),
      accountName: z.string().optional().nullable(),
      accountNumber: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
  expenseAccount: z
    .object({
      id: z.number().optional().nullable(),
      accountName: z.string().optional().nullable(),
      accountNumber: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
});
